import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ e("path", {
  fill: "#FFDA44",
  d: "M29.565 2.432A19.91 19.91 0 0 0 20 0a19.91 19.91 0 0 0-9.565 2.432L8.695 20l1.74 17.568A19.911 19.911 0 0 0 20 40c3.465 0 6.724-.882 9.565-2.432L31.305 20l-1.74-17.568Z"
}, null, -1), c = /* @__PURE__ */ e("path", {
  fill: "#338AF3",
  d: "M10.435 37.568V2.432C4.218 5.824 0 12.419 0 20c0 7.58 4.218 14.176 10.435 17.568Z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  fill: "#6DA544",
  d: "M40 20c0-7.58-4.218-14.176-10.435-17.568v35.136C35.782 34.176 40 27.581 40 20Zm-24.348 5.217L12.174 20l3.478-5.217L19.131 20l-3.479 5.217Zm8.696 0L20.869 20l3.479-5.217L27.826 20l-3.478 5.217ZM20 32.174l-3.478-5.218L20 21.74l3.478 5.217L20 32.174Z"
}, null, -1), d = [
  o,
  c,
  s
];
function i(r, _) {
  return l(), t("svg", n, [...d]);
}
const a = { render: i };
export {
  a as default,
  i as render
};
